import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import * as styles from "./Grid.module.scss";


export const Grid = ({ children, className, half, medium, snap, small }) => (
  <div className={cn(styles.el, {
    [styles.elSnap]: snap,
    [styles.elMedium]: medium,
    [styles.elSmall]: small,
    [styles.elHalf]: half,
  }, className)}>{children}</div>
);

export const GridItem = ({ children, className, id, cols }) => (
  <div className={cn(styles.gridItem, {
    [styles[`gridItemCols${cols}`]]: cols,
  }, className)} id={id}>{children}</div>
);

Grid.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  snap: PropTypes.bool,
  small: PropTypes.bool,
};
